<template>
  <main class="mt-5">
    <div class="card mt-3">
      <div
        class="card-header align-items-center justify-content-between border-0"
      >
        <h5 class="card-title font-bold">مدیریت تنظیمات تخفیف تولد :</h5>
        <div class="d-flex align-items-center">
          <button
            :disabled="disabled"
            type="button"
            @click="submitChanges"
            class="btn btn-success ml-2"
          >
            ثبت تغییرات
          </button>
        </div>
      </div>
      <div class="card-body">
        <div v-if="items && !$root.isEmptyObject(items)" class="row">
          <b-form-group label="تعداد روز اعتبار تخفیف" class="col-md-5">
            <b-form-input
              type="number"
              v-model="items.days_birth_date_discount_active"
            />
          </b-form-group>
          <b-form-group
            label="تعداد مجاز برای استفاده از تخفیف"
            class="col-md-5"
          >
            <b-form-input
              type="number"
              v-model="items.max_birth_date_discount_usage"
            />
          </b-form-group>
        </div>
        <div v-else class="alert alert-danger">
          موردی یافت نشد
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import BirthdaySettingsImpl from "@@/core/pages/customerClub/clubSettings/birthdaySettings/BirthdaySettingsImpl.js";
export default {
  extends: BirthdaySettingsImpl,
};
</script>
